<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="`[${selectedObj.objName}] SNMP트랩 수집 설정`" width="600px" @close="close">
    <div slot="content">
      <el-steps :active="activeStep" finish-status="success">
        <el-step v-for="(step, index) in stepTitles" :key="index" :title="`${index + 1}.${step}`"></el-step>
      </el-steps>
      <div class="title-h4 mr-b10">관리 대상 정보</div>
      <div class="list form-list mr-b25">
        <el-form label-position="left">
          <el-form-item label="장비명" label-width="120px">{{ getValueAfterCheckEmpty(selectedObj.objName) }}</el-form-item>
          <el-form-item label="IP주소" label-width="120px">{{ getValueAfterCheckEmpty(selectedObj.ipaddressIpv4) }}</el-form-item>
          <el-form-item label="장비종류" label-width="120px">{{ getValueAfterCheckEmpty(selectedObj.objtypeName) }}</el-form-item>
          <el-form-item label="제조사" label-width="120px">{{ getValueAfterCheckEmpty(selectedObj.objCompanyName) }}</el-form-item>
          <el-form-item label="버전" label-width="120px">{{ getValueAfterCheckEmpty(selectedObj.objProductId) }}</el-form-item>
          <el-form-item label="수집여부" label-width="120px">
            <el-switch v-model="selectedObj.rawdataSaveFlagSnmptrap" active-value="1" inactive-value="0" />
          </el-form-item>
        </el-form>
      </div>
      <div v-if="isTrue(selectedObj.rawdataSaveFlagSnmptrap)">
        <w-file-setting-popup-content ref="fileContent" v-show="activeStep === 1" :log-info="trapInfo" @go-to-next="goToNext"/>
        <w-pattern-setting-popup-content ref="patternContent" v-show="activeStep === 2" :log-info="trapInfo" @update-log-info="onUpdateLogInfo" />
      </div>
    </div>
    <el-row v-if="isTrue(selectedObj.rawdataSaveFlagSnmptrap)" slot="footer" type="flex" justify="space-between">
      <div>
        <el-button size="large" v-show="activeStep === 2" @click="onPrevStep">
          <i class="fal fa-arrow-left mr-r2"></i>
          이전
        </el-button>
      </div>
      <div>
        <el-button size="large" v-show="activeStep === 1" type="solid" @click="onNextStep">다음</el-button>
        <el-button size="large" v-show="activeStep === 2" type="solid" @click="onSaveButton">완료</el-button>
        <el-button size="large" @click="onCloseButton">취소</el-button>
      </div>
    </el-row>
    <el-row v-else slot="footer" type="flex" justify="end">
      <div>
        <el-button size="large" type="solid" @click="onChangeSaveFlag">확인</el-button>
        <el-button size="large" @click="onCloseButton">취소</el-button>
      </div>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { isEmpty, isNil, cloneDeep } from 'lodash';
import { isTrue } from '@/utils/boolean';

import IntegratedTrapSettingAPI from '@/api/settings/log/integrated-trap-settings';
import msgUtils from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';

import WFileSettingPopupContent from '@/views/settings/log-analysis/Collect/Syslog/components/FileSettingPopupContent';
import WPatternSettingPopupContent from '@/views/settings/log-analysis/Collect/Syslog/components/PatternSettingPopupContent';

export default {
  name: 'WObjCollectSettingPopup',
  components: {
    WFileSettingPopupContent,
    WPatternSettingPopupContent,
  },
  data() {
    return {
      // stepTitles: ['수집 설정', '저장소 설정'],
      activeStep: 1,
      selectedObj: {},
      selectedObjClone: {},
      trapInfo: {},
      loading: false,
    };
  },
  computed: {
    stepTitles() {
      if (isTrue(this.selectedObj.rawdataSaveFlagSnmptrap)) {
        return ['수집 설정', '패턴 설정'];
      }
      return ['수집 여부 설정'];
    },
  },
  methods: {
    isTrue,
    getValueAfterCheckEmpty,
    /**
     * 선택한 장비의 log info를 조회해온다.
     * @author Minyeong
     * @param  {[type]} selectedObj [description]
     * @return {[type]}             [description]
     */
    loadLogInfo(selectedObj) {
      // logType & logTargetId = TRAP, objId로 네트워크 장비 트랩의 로그 객체 정보 조회
      if (!isEmpty(selectedObj) && !isNil(selectedObj.objId) && isTrue(selectedObj.rawdataSaveFlagSnmptrap)) {
        const params = {
          params: {
            objId: selectedObj.objId,
          },
        };

        IntegratedTrapSettingAPI.getLogInfoByObjId(params).then((response) => {
          if (response.data.success) {
            this.trapInfo = response.data.data;
            this.trapInfo.objId = selectedObj.objId;
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, 'SNMP 트랩 정보', false));
          throw new Error(e);
        });
      }
    },
    /**
     * 수집 설정 완료 버튼을 누르면 pattern content의 validation 체크를 한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveButton() {
      this.$refs.patternContent.checkValidation();
    },
    /**
     * 수집 설정이 ON일 때 수집서버/파일 및 암호화/저장소 및 패턴 데이터를 로그 정보에 저장한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onUpdateLogInfo() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      // 원래 장비의 수집 설정이 OFF였을 경우(OFF > ON) Trap 수집 여부를 먼저 ON으로 변경한 뒤에 로그 정보를 업데이트한다.
      if (!isTrue(this.selectedObjClone.rawdataSaveFlagSnmptrap)) {
        this.updateTrapFlag().then((response) => {
          if (response.data.success) {
            const params = {
              params: {
                objId: this.selectedObj.objId,
              },
            };
            // 등록된 로그 객체의 정보를 조회(log_id)
            IntegratedTrapSettingAPI.getLogInfoByObjId(params).then((res) => {
              if (res.data.success) {
                this.trapInfo.logId = res.data.data.logId;
                this.trapInfo.logType = res.data.data.logType;
                this.trapInfo.logTargetId = res.data.data.logTargetId;
                this.trapInfo.registDatetime = res.data.data.registDatetime;
                this.trapInfo.objId = this.selectedObj.objId;
                this.updateTrapLogInfo();
              }
            }).catch((e) => {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, 'SNMP 트랩 정보', false));
              throw new Error(e);
            }).finally(() => {
              this.loading = false;
            });
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, 'SNMP 트랩 정보', response.data.success));
            this.loading = false;
          }
        });
      } else {
        this.updateTrapLogInfo();
      }
    },
    /**
     * 수집 설정이 ON일 때 수집서버/파일 및 암호화/저장소 및 패턴 데이터를 로그 정보에 저장한다.
     * @author Minyeong
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    updateTrapLogInfo() {
      const patternParam = this.$refs.patternContent.getPatternParam();
      this.trapInfo = {
        ...this.trapInfo,
        dataindexId: patternParam.dataindexId,
        patternId: patternParam.patternId,
        mlFlag: patternParam.mlFlag,
      };
      IntegratedTrapSettingAPI.updateTrapLogInfo(this.trapInfo).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, 'SNMP 트랩 정보', response.data.success));
          this.$emit('load-target-data');
          this.onCloseButton();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, 'SNMP 트랩 정보', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, 'SNMP 트랩 정보', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 수집 여부를 OFF로 설정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onChangeSaveFlag() {
      // 수집 설정을 OFF할 때
      this.updateTrapFlag().then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, 'SNMP 트랩', response.data.success));
          this.$emit('load-target-data');
          this.onCloseButton();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, 'SNMP 트랩 정보', response.data.success));
        }
      });
    },
    /**
     * 수집 여부를 OFF로 설정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    updateTrapFlag() {
      const params = [this.selectedObj];

      return IntegratedTrapSettingAPI.updateTrapFlag(params);
    },
    onCloseButton() {
      this.$refs.slidingPopup.close();
    },
    onNextStep() {
      this.$refs.fileContent.checkValidation();
    },
    goToNext() {
      this.activeStep = 2;
    },
    onPrevStep() {
      this.activeStep = 1;
    },
    initTrapInfo() {
      this.trapInfo = {
        logSaveFileFlag: true,
        compressFlag: false,
        encryptFlag: false,
        encryptPw: '',
        retentionAge: 0,
        logCollectorId: null,
        dataindexId: null,
        patternId: null,
      };
    },
    open(selectedObj) {
      this.selectedObj = cloneDeep(selectedObj);
      this.selectedObjClone = selectedObj;
      this.loadLogInfo(selectedObj);
      this.$refs.slidingPopup.open();
    },
    close() {
      this.initTrapInfo();
      this.activeStep = 1;
      if (isTrue(this.selectedObj.rawdataSaveFlagSnmptrap)) {
        this.$refs.patternContent.initValidation();
        this.$refs.fileContent.initValidation();
        this.$refs.patternContent.initData();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/SnmpTrap/popup/ObjCollectSettingPopup.vue